import React, {useState, useEffect, useContext} from 'react'

import {
    Grid,
    Button,
    Typography,
    IconButton,
    Card,
    CardActions,
    CardContent,
    Avatar,
    Divider,
    Popover,
} from '@material-ui/core'
import {useSettings} from '../../../utils/Settings'
import {MyAccountContext} from '../../containers/Layout'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Logo from '../../../components/Logo'
import {Redirect} from 'react-router-dom'
import {getProgramConfiguration, getLoginProfileDetails} from '../../../services/outReach'
import {logoURLAtom, altlogoURLAtom} from '../Layout'
import {useRecoilState} from 'recoil'

const Navbar = props => {
    const [loggedInUserData, setLoggedInUserData] = useState('')
    const {logout, showManageAccont} = useSettings()
    // const {toggleManageAccount} = useContext(MyAccountContext)
    // const [loading2, setLoading2] = useState(true)
    // const [welcomeProps, setWelcomeProps] = useState([])
    const [logoUrl, setLogoUrl] = useRecoilState(logoURLAtom)
    const [altlogoUrl, setAltLogoUrl] = useRecoilState(altlogoURLAtom)

    useEffect(() => {
        const callApi = async () => {
            const promise1 = new Promise(async (resolve, reject) => {
                // const response = await getProgramConfiguration()
                // if (Object.keys(response).length > 0) {
                //     // setLogoUrl(response.configuration.logoUrl)
                //     // setWelcomeProps(response.configuration.welcome)
                // } else {
                //     reject(true)
                //     // setLoading2(false)
                // }
                resolve(true)
            })
            const promise2 = new Promise(async (resolve, reject) => {
                const result = await getLoginProfileDetails()
                if (Object.keys(result).length > 0) setLoggedInUserData(result.user)
                else {
                    reject(true)
                    // setLoading2(false)
                }
                resolve(true)
            })
            Promise.all([promise1, promise2])
                .then(function(values) {
                    // setLoading2(false)
                    // console.log('Navbar.js .then Promise->', values)
                })
                .catch(function(error) {
                    // console.log('Navbar.js .catch Promise->', error)
                })
        }
        callApi()
    }, [])

    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)
    const id = open ? 'simple-popover' : undefined
    let loginName = ''

    const getLoginNameInitials = () => {
        loginName = loggedInUserData.firstname + ' ' + loggedInUserData.lastname

        let charsArray = loginName.match(/\b\w/g) || []
        const initials = (
            (charsArray.shift() || '') + (charsArray.pop() || '')
        ).toUpperCase()

        return initials
    }

    const handleClickOnLogo = event => setAnchorEl(event.currentTarget)

    const handleCloseOnLogo = () => setAnchorEl(null)

    if (showManageAccont) return <Redirect to="/myaccount" />
    return (
        <Grid
            className="page-header-stack--general"
            onClick={() => props.handleDrawerClose()}
        >
            <Grid
                className={`fi-stack__item fi-brand__logo ${
                    altlogoUrl ? 'alt-logo-container' : ''
                }`}
            >
                <Logo imgSrc={logoUrl} />
                {altlogoUrl && <Logo imgSrc={altlogoUrl} className="alt-logo-url" />}
            </Grid>
            <Grid className="fi-stack__item fi-brand__tools">
                <Grid className="brand-action-icon-container">
                    <div className="profile-user-icon__menu">
                        <IconButton
                            aria-describedby={id}
                            variant="contained"
                            onClick={handleClickOnLogo}
                        >
                            <FontAwesomeIcon
                                icon={['fal', 'user-circle']}
                            ></FontAwesomeIcon>
                        </IconButton>
                        {loggedInUserData && (
                            <Popover
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleCloseOnLogo}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                className="profile-user__popup-menu"
                            >
                                <Card className="profile-menu__tooltip_card">
                                    <CardContent>
                                        <Avatar className="user-image__avtar">
                                            {getLoginNameInitials()}
                                        </Avatar>
                                        <Typography
                                            className="profile-user-name__h5"
                                            variant="h5"
                                            component="h2"
                                        >
                                            {loginName}
                                        </Typography>
                                        {/* <Typography
                                            className="profile-user-role__p"
                                            color="textSecondary"
                                            gutterBottom
                                        >
                                            {loggedInUserData.roles}
                                        </Typography> */}

                                        <Typography
                                            className="profile-user-email__p"
                                            color="textSecondary"
                                            gutterBottom
                                        >
                                            <FontAwesomeIcon
                                                icon={['fal', 'envelope']}
                                            ></FontAwesomeIcon>{' '}
                                            {loggedInUserData.emailaddress}
                                        </Typography>
                                        {/* <>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => {
                                                toggleManageAccount()
                                            }}
                                        >
                                            {showManageAccont
                                                ? 'GO TO DASHBOARD'
                                                : 'MANAGE ACCOUNT'}
                                        </Button>
                                    </> */}
                                    </CardContent>
                                    <Divider />
                                    <CardActions className="profile-signout-btn__container">
                                        <Button
                                            color="primary"
                                            onClick={() => {
                                                logout()
                                            }}
                                            style={{
                                                float: 'right',
                                                top: '0px',
                                            }}
                                        >
                                            {loggedInUserData.multipleprograms
                                                ? 'Sign out of all accounts'
                                                : 'Sign out'}
                                        </Button>
                                    </CardActions>
                                </Card>
                            </Popover>
                        )}
                    </div>
                </Grid>
            </Grid>
        </Grid>
    )
}

Navbar.defaultProps = {
    handleDrawerClose: () => {},
}

export default Navbar
